import type { SSEStreamService } from '@patsnap-utils/sse';
import { TokenUsage } from './common.interface';

export interface ApiTranslationSyncRequest {
    current_step: string;
    task_id: string;
}

export interface TranslationSyncContentItem {
    src_text: string;
    translated_text: string;
    graph_index: number;
}

export interface ApiTranslationSyncResponse {
    status: string;
    token_usage: TokenUsage;
    content: TranslationSyncContentItem[];
}

export const TranslationSync = Symbol('TranslationSync');

export interface TranslationSync {
    translationSync(data: ApiTranslationSyncRequest): SSEStreamService<ApiTranslationSyncResponse>;
}